import {
  GET_BUSINESS_RULES,
  GET_BUSINESS_RULE_RESPONSE_HANDLER,
  GET_RULE_CONDITION_EVALUATOR_RESPONSE_HANDLER,
  DELETE_BUSINESS_RULE_RESPONSE_HANDLER,
} from "../actions/types";

export default (state = {}, action) => {
  let status = 200;
  let data = {};
  let notificationType = "info";
  if (
    action.payload != undefined &&
    typeof action.payload.status != "undefined"
  ) {
    status = action.payload.status;
    notificationType = "success";
    if (status >= 400) {
      notificationType = "error";
    }
    data = action.payload.data;
  }

  let response = {
    notificationType: notificationType,
    type: action.type,
    status: status,
    action: "LIST",
  };
  switch (action.type) {
    case GET_BUSINESS_RULES:
      response["data"] = data.rules;
      break;
    case GET_BUSINESS_RULE_RESPONSE_HANDLER:
      response["data"] = action.payload.data;
      response["action"] = "ACTION";
      break;
    case DELETE_BUSINESS_RULE_RESPONSE_HANDLER:
      response["data"] = action.payload.data;
      response["action"] = "DELETE";
      break;

    case GET_RULE_CONDITION_EVALUATOR_RESPONSE_HANDLER:
      response["data"] = action.payload.data;
      response["action"] = "ACTION";
      break;
    default:
      return state;
  }
  return response;
};
